export type RightRailGuardEventName =
  | 'timelining:meetings-request-close'
  | 'timelining:report-request-close'
  | 'timelining:checklist-request-close'
  | 'timelining:forms-request-close'
  | 'timelining:design-request-close'
  | 'timelining:overview-request-close'

export type RightRailGuardDecision = {
  eventName: RightRailGuardEventName
  respectHandledFlag: boolean
}

export type RightRailGuardInput = {
  activeLayoutView: string
  reportRoutePage?: string
  checklistRouteActive: boolean
  hasActiveCanvasItem: boolean
}

export const selectRightRailNavigationGuard = ({
  activeLayoutView,
  reportRoutePage,
  checklistRouteActive,
  hasActiveCanvasItem,
}: RightRailGuardInput): RightRailGuardDecision | null => {
  if (activeLayoutView === 'MEETINGS') {
    return { eventName: 'timelining:meetings-request-close', respectHandledFlag: true }
  }
  if (activeLayoutView === 'REPORTS' && reportRoutePage === 'NEW') {
    return { eventName: 'timelining:report-request-close', respectHandledFlag: false }
  }
  if (activeLayoutView === 'CHECKLISTS' || (checklistRouteActive && hasActiveCanvasItem)) {
    return { eventName: 'timelining:checklist-request-close', respectHandledFlag: false }
  }
  if (activeLayoutView === 'FORMS') {
    return { eventName: 'timelining:forms-request-close', respectHandledFlag: false }
  }
  if (activeLayoutView === 'DESIGN') {
    return { eventName: 'timelining:design-request-close', respectHandledFlag: false }
  }
  if (activeLayoutView === 'OVERVIEW') {
    return { eventName: 'timelining:overview-request-close', respectHandledFlag: true }
  }
  return null
}
